import PropTypes from 'prop-types';
import { useInView } from '../../hooks/useInView';
import './Reveal.css';

/**
 * Появление блока при прокрутке до него.
 *
 * ## Зачем обёртка, а не правило на всех подряд
 *
 * Появляться должны СЕКЦИИ, а не каждый элемент: страница, где проступает
 * всё сразу, читается как медленно грузящаяся, а не как живая. Обёртка
 * заставляет выбирать, что именно показывать с задержкой.
 *
 * ## Что здесь обязательно
 *
 * - **Ветка `prefers-reduced-motion`** — в CSS, той же специфичности и после
 *   правил появления, иначе она молча проигрывает.
 * - **Начальное состояние применяется только если наблюдатель есть.** Без
 *   `IntersectionObserver` (старый браузер) `useInView` сразу отвечает «в
 *   кадре», и блок отрисуется как обычно. Иначе половина сайта осталась бы
 *   прозрачной навсегда.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {number} [props.delay] — задержка в мс, чтобы соседние блоки
 *   проступали не одновременно.
 * @param {string} [props.as] — тег обёртки: секция остаётся секцией.
 * @param {string} [props.className]
 */
export const Reveal = ({ children, delay = 0, as: Tag = 'div', className = '', ...rest }) => {
  const [ref, visible] = useInView({ threshold: 0.12 });

  return (
    <Tag
      ref={ref}
      className={`reveal${visible ? ' reveal--visible' : ''}${className ? ` ${className}` : ''}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
};

Reveal.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
  as: PropTypes.string,
  className: PropTypes.string,
};

export default Reveal;
